import axios from '../config.js';
const resource = '/case/note';

export default {
  create(payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.post(resource, payload);
  },
  update(id='', payload) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    
    var data = {
      _method: 'PUT',
      ...payload
    }

    return axios.put(`${resource}/${id}`, data);
  },
  delete(id) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`
    return axios.delete(`${resource}/${id}`);
  },
};